<template>
    <v-dialog
        v-model="show"
        width= 50%
        persistent
        outline
    >
      <v-card>
        <v-card-title class="headline" primary-title>
          <span class="capitalize">{{ action }} {{ itemType }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-6">
          <div>
            <p>Are you sure you want to {{ action }} this {{ itemType }}?</p>
            <div class="warning--text">{{ advisory }}</div>
          </div>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn
              data-testid="cancel-modal-btn"
              class="cancel-modal-btn"
              color="error"
              @click.stop="collapse"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
              data-testid="delete-modal-btn"
              class="delete-modal-btn"
              color="primary"
              @click.stop="handleDelete"
          >
              {{ action }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    noButton: {
      type: Boolean
    },
    deleteItem: {
      type: String
    },
    itemType: {
      type: String
    },
    advisory: {
      type: String
    },
    actionType: {
      type: String
    },
    buttonColor: {
      type: String
    }
  },

  methods: {
    handleDelete() {
      this.show = false;
      this.$emit("delete");
    },

    collapse() {
      this.show = false;
      this.$emit("collapse");
    }
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },

    action() {
      return this.actionType ? this.actionType : "delete";
    },

    color() {
      return this.buttonColor ? this.buttonColor : "error";
    }
  }
};
</script>

<style scoped>
    .capitalize {
        text-transform: capitalize;
    }

</style>
